



























import { computed, defineComponent } from "@vue/composition-api";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "WebAppMenu",
  components: { BaseIcon, BaseIconButton },
  setup() {
    const { authUser } = useAuthUser();
    const { balance } = useBalance();

    const isMember = computed(() => checkRole(authUser.value?.role ?? "", "member"));

    const refreshPage = () => {
      window.location.reload();
    };

    const showRefill = () => {
      emitter.emit(EVENTS.BALANCE_REFILL_SHOW, true);
    };

    return {
      authUser,
      balance,
      isMember,
      refreshPage,
      showRefill,
    };
  },
});
